import avenida from "../images/avenida.jpeg";
import baxiFerrol from "../images/Baxi_ferrol.jpeg";
import barcaCBS from "../images/Barca_cbs.jpeg";
import cadilaseu from "../images/sedi.jpeg";
import zaragoza from "../images/zaragoza.jpeg";
import celtaZorka from "../images/celta_zorka.jpeg";
import duran from "../images/duran_ensino.jpeg";
import pajariel from "../images/pajariel.jpeg";
import jairis from "../images/jairis_global.jpeg";
import idk from "../images/idk.jpeg";
import kutxa from "../images/kutxabanl.jpeg";
import lointek from "../images/lointek.jpeg";
import movistart from "../images/movistar.jpeg";
import spar from "../images/spar.jpeg";
import sparGran from "../images/spar_gran_canaria.jpeg";
import valencia from "../images/valencia_bc.jpeg";

export interface Team {
  name: string;
  id: number;
  picture: string;
}

export const Teams: Team[] = [
  { name: "Araski AES", id: 0, picture: kutxa },
  { name: "Barcelona CBS", id: 1, picture: barcaCBS },
  { name: "Baxi Ferrol", id: 2, picture: baxiFerrol },
  { name: "CB Bembibre", id: 3, picture: pajariel },
  { name: "CB Leganes", id: 4, picture: "" },
  { name: "CB Movistar Estudiantes", id: 5, picture: movistart },
  { name: "CB Nissan Al Qazeres", id: 6, picture: "" },
  { name: "CB Perfumerias Avenida", id: 7, picture: avenida },
  { name: "CD Campus Promete", id: 8, picture: "" },
  { name: "CD Zamarat", id: 9, picture: "" },
  { name: "Cadi La Seu", id: 10, picture: cadilaseu },
  { name: "Ciudad de La Laguna", id: 11, picture: "" },
  { name: "Duran Ensino Lugo", id: 12, picture: duran },
  { name: "Gernika KESB", id: 13, picture: lointek },
  { name: "Gran Canaria", id: 14, picture: sparGran },
  { name: "IDK Gipuzkoa UPV", id: 15, picture: idk },
  { name: "Probelte Jairis", id: 16, picture: jairis },
  { name: "UNI Girona CB", id: 17, picture: spar },
  { name: "Valencia BC", id: 18, picture: valencia },
  { name: "Zaragoza", id: 19, picture: zaragoza },
];

export interface PopupStatistic {
  data: [number];
  min: number;
  max: number;
  mean: number;
}

export interface PopupData {
  league: PopupStatistic;
  team: PopupStatistic;
}

export interface BinData {
  start: number;
  end: number;
  count: number;
}

export type Tactics =
  | "transition"
  | "on ball screen outside"
  | "on ball screen inside"
  | "off ball screen outside"
  | "off ball screen inside"
  | "isolation";

// rose blue-950
export const colors = [" #c82121", "#becbff", "#0d0cb5", "#dee1ec"];

export interface TacticStat {
  efficiency: number;
  usage: number;
  lock?: [boolean, boolean];
}

export interface TacticScale {
  transition: {
    efficiency: { min: number; max: number };
    usage: { min: number; max: number };
  };
  "on ball screen outside": {
    efficiency: { min: number; max: number };
    usage: { min: number; max: number };
  };
  "on ball screen inside": {
    efficiency: { min: number; max: number };
    usage: { min: number; max: number };
  };
  "off ball screen outside": {
    efficiency: { min: number; max: number };
    usage: { min: number; max: number };
  };
  "off ball screen inside": {
    efficiency: { min: number; max: number };
    usage: { min: number; max: number };
  };
  isolation: {
    efficiency: { min: number; max: number };
    usage: { min: number; max: number };
  };
}

export interface TacticsData {
  home: {
    transition: TacticStat;
    "on ball screen outside": TacticStat;
    "on ball screen inside": TacticStat;
    "off ball screen outside": TacticStat;
    "off ball screen inside": TacticStat;
    isolation: TacticStat;
  };
  away: {
    transition: TacticStat;
    "on ball screen outside": TacticStat;
    "on ball screen inside": TacticStat;
    "off ball screen outside": TacticStat;
    "off ball screen inside": TacticStat;
    isolation: TacticStat;
  };
}
